module.exports = __webpack_public_path__ + "static/media/Chandra.3f50206d.jpg";